@if (isLoading) {
  <div style="text-align: -webkit-center;">
    <mat-spinner style="margin-top: 30%;" [diameter]="70"> </mat-spinner>
  </div>
}